/** インラインワーカーコード: ユニーク値計算 チャンクごとにユニーク値を計算して累積 */
const workerFunction = () => {
  return `
  /**
   * 値を文字列に変換
   * @param {any} value
   * @returns {string}
   */
  function convertValuesToString(value) {
    if (value === null || value === undefined) return ''
    if (typeof value === 'string') return value
    if (typeof value === 'number') return String(value)
    if (value instanceof Date) return value.toISOString()
    return String(value)
  }

  /**
   * チャンク内のユニーク値を計算して返す。
   * 累積マップはメインスレッド側が保持・合算する（チャンクごとに累積マップ全体を
   * ワーカーと往復させると、大容量ファイルで転送コストが増大し続けるため）。
   * @param {string[][]} chunk
   * @param {string[]} headers
   * @returns {Object} - 列名ごとのユニーク値配列（このチャンク分のみ）
   */
  function calculateUniqueValuesPerColumn(chunk, headers) {
    const uniqueValuesMap = {}
    if (!chunk || chunk.length === 0) return uniqueValuesMap

    // 重複判定は配列のincludes（総当たり）ではなくSetで行う。
    // ユニーク値が数十万件に達するファイルではincludesが実質終わらないため（#大容量CSV無反応事象）
    const uniqueValueSets = {}
    headers.forEach((header) => {
      uniqueValuesMap[header] = []
      uniqueValueSets[header] = new Set()
    })

    chunk.forEach((row) => {
      headers.forEach((header, columnIndex) => {
        const value = convertValuesToString(row[columnIndex] || '')

        if (!uniqueValueSets[header].has(value)) {
          uniqueValueSets[header].add(value)
          uniqueValuesMap[header].push(value)
        }
      })
    })

    return uniqueValuesMap
  }

  self.onmessage = function (e) {
    try {
      const { chunk, headers } = e.data

      const updatedUniqueValuesMap = calculateUniqueValuesPerColumn(chunk, headers)

      self.postMessage({
        success: true,
        uniqueValuesMap: updatedUniqueValuesMap
      })
    } catch (error) {
      console.error('Error in unique values worker:', error)
      self.postMessage({
        success: false,
        error: error.message
      })
    }
  }
  `
}

export const workerCode = workerFunction()
